module.exports = __webpack_public_path__ + "static/media/PM96.fc63c6d9.png";